export default __webpack_public_path__ + "images/0x5bff88ca1442c2496f7e475e9e7786383bc070c0.png";